import { httpClient } from '@/api/http-client'
import { Company } from '@/types'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'

type Params = {
  companyKey: string
}

export const readCompany = async ({ companyKey }: Params) => {
  const response = await httpClient('accounting-dealer').get<Company>(
    `/v3/company/${companyKey}`,
  )
  return response.data
}

export const useReadCompany = (
  { companyKey }: Params,
  options?: Partial<UseQueryOptions<Company>>,
) => {
  return useQuery({
    queryKey: ['company', companyKey],
    queryFn: () => readCompany({ companyKey }),
    ...options,
  })
}
